import { Link } from 'react-router-dom';
import { CATEGORIES } from '@/mocks/categories';
import SectionHeading from '@/components/feature/SectionHeading';

export default function CategoryGrid() {
  return (
    <section id="categories" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="TOPIC INDEX"
          title="按专题回溯那些被折叠的角落"
          description="六个固定专题覆盖了中文互联网最常见的「消失现场」，每个专题下都按年份排好了索引，可以直接顺着时间线往回翻。"
          action={
            <Link
              to="/archive"
              className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部档案
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CATEGORIES.map((cat) => (
            <Link
              key={cat.id}
              to={`/archive?category=${cat.id}`}
              className="group relative rounded-lg overflow-hidden border border-background-200 bg-background-100 aspect-[4/3] cursor-pointer"
            >
              <img
                src={cat.cover}
                alt={`${cat.name}专题封面：${cat.desc}`}
                title={`${cat.name} - 黑料百科专题档案`}
                className="absolute inset-0 w-full h-full object-cover object-top opacity-45 group-hover:opacity-65 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/70 to-background-50/20"></div>
              <div className="relative z-10 h-full p-6 flex flex-col">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500/10 border border-primary-500/30 text-primary-500 text-xl">
                  <i className={cat.icon}></i>
                </span>
                <div className="mt-auto">
                  <span className="text-[10px] tracking-[0.3em] text-primary-500">{cat.en}</span>
                  <h3 className="mt-2 font-heading text-xl text-foreground-950 group-hover:text-primary-500 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {cat.desc}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-2 text-xs text-foreground-700">
                    <i className="ri-file-list-3-line text-primary-500"></i>
                    已收录 {cat.count} 条
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}